import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/qna/page.client.tsx");
